import { render, staticRenderFns } from "./newProductReviews.vue?vue&type=template&id=53eb31b6&scoped=true"
import script from "./newProductReviews.vue?vue&type=script&lang=js"
export * from "./newProductReviews.vue?vue&type=script&lang=js"
import style0 from "./newProductReviews.vue?vue&type=style&index=0&id=53eb31b6&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./newProductReviews.vue?vue&type=style&index=2&id=53eb31b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb31b6",
  null
  
)

export default component.exports